<template>
  <section class="breadcrumbs">
    <div class="container">
      <ul class="breadcrumb">
        <li
          v-for="(breadcrumb, idx) in breadcrumbList"
          :key="idx"
          class="breadcrumb-item"
          :class="{'active': !breadcrumb.link}"
        >
          <router-link
            v-if="breadcrumb.link"
            :to="routeTo(idx)"
            v-html="breadcrumb.name"
          ></router-link>
          <span
            v-else
            v-html="breadcrumb.name"
          ></span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  export default {
    name: "Breadcrumbs",
    data() {
      return {
        breadcrumbList: []
      };
    },
    mounted() {
      this.updateList();
    },
    watch: {
      $route() {
        this.updateList();
      }
    },
    methods: {
      routeTo(pRouteTo) {
        if (this.breadcrumbList[pRouteTo].link)
          return this.breadcrumbList[pRouteTo].link;
      },
      updateList() {
        this.breadcrumbList = this.$route.meta.breadcrumb;
      }
    }
  };
</script>